const replaceId = (idToParse, replaceString) => {
  return idToParse.replace(replaceString, "");
};

export { replaceId };
